'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$scope', 'OrgService',
    function ($scope, OrgService) {
        $scope.orgs = [];

        OrgService.api.get({sorts: ['shortName:ASC']}, (data) => $scope.orgs = [{
            id: null,
            shortName: "<Все>"
        }].concat(data._embedded));
    }];
